import { render, staticRenderFns } from "./BanWowStreamer.vue?vue&type=template&id=c743aff6&scoped=true"
import script from "./BanWowStreamer.vue?vue&type=script&lang=js"
export * from "./BanWowStreamer.vue?vue&type=script&lang=js"
import style0 from "./BanWowStreamer.vue?vue&type=style&index=0&id=c743aff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c743aff6",
  null
  
)

export default component.exports